import React, { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';

import { theme } from 'theme';
import { GlobalStyles } from './GlobalStyles';
import Header from '../Header';
import Footer from '../Footer';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const MainContent = styled.main`
  display: flex;
  flex-direction: column;

  ${theme.breakpoints.maxTablet} {
    padding-top: 6.4rem;
  }
`;

const navigation = [
  {
    link: {
      to: '/about',
      name: 'About',
    },
  },
  {
    link: {
      to: '/work',
      name: 'Work',
    },
  },
  {
    link: {
      to: '/services',
      name: 'Services',
    },
  },
  // {
  //   link: {
  //     to: '/blog',
  //     name: 'Blog',
  //   },
  // },
  {
    link: {
      to: '/contact',
      name: 'Contact',
    },
  },
];

export const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles lockScroll={isMenuOpen} />
      <LayoutContainer>
        <Header
          isMenuOpen={isMenuOpen}
          navigation={navigation}
          toggleMobileMenu={toggleMobileMenu}
        />
        <MainContent>{children}</MainContent>
        <Footer navigation={navigation} />
      </LayoutContainer>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
